import React, { Component, Fragment } from 'react'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPincodeData } from "../../actions/pincode"
import { updateUserAddr } from "../../actions/updUserAddr";
import { getPincodeDataAxios } from "../../actions/pincode";
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import Select from 'react-dropdown-select';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import {useLocation} from 'react-router-dom';
import { updateEasyProfileMember,registerEasyAccount, updateCapillaryProfileMember, registerCapillaryAccount, capillarySearchMember } from '../../actions/easyRewards';
import { updateUserInfo as updateUser } from "../../actions/user";
import { updateUserInfo } from '../../actions/updUserInfo';
var loading = <img src={require('../../assets/images/loader.gif')} width={20} height={20} />;

// Url's
const getCountryDataUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-country-list`;
const getStateDataUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-state-list`;
const getTownDataUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-town-list`;
const getStateCityZipUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-state-city-by-zipcode`;



export class AddressInfo extends Component {

  constructor() {
    super()
    // this.validator = new SimpleReactValidator();

    this.validator = new SimpleReactValidator({
      messages: {
        regex: 'Special char not allowed.'
      },
      validators: {
        regex: {
          message: 'Special char not allowed.',
          rule: (val, params, validator) => {
            return /^[a-zA-Z0-9\s-_\[\]\(\),.:;\\=#&/]+$/.test(val);
          },
          messageReplace: (message, params) => message.replace(':values', params)
        }
      }
    });
    this.state = {
      ship_addr_1: "",
      ship_addr_2: "",
      ship_addr_3: "",
      ship_pin: "",
      ship_town_name: "",
      ship_town_id : "",
      ship_country_name: "",
      ship_country_id: "",
      ship_state_name: "",
      ship_state_id : "",
      bill_addr_1: "",
      bill_addr_2: "",
      bill_addr_3: "",
      bill_pin: "",
      bill_town_name: "",
      bill_town_id: "",
      bill_country_name: "",
      bill_country_id:"",
      bill_state_name: "",
      bill_state_id:"",
      pin_message: "",
      countryLoading: false,
      countryData: [],
      countrySelected: null,
      stateLoading: false,
      stateData: [],
      stateSelected: null,
      townLoading: false,
      townData: [],
      townSelected: null,
      bill_countryLoading: false,
      bill_countryData: [],
      bill_countrySelected: null,
      bill_stateLoading: false,
      bill_stateData: [],
      bill_stateSelected: null,
      bill_townLoading: false,
      bill_townData: [],
      bill_townSelected: null,
      isCopy: false,
    }
  }

 async componentDidMount() {

   const {capillaryDetails,capillaryFlag} = this.props
   

    const data = {
               mobile_no: localStorage.getItem('mobile_no'),
               connection_id:this.props.connection_id
             };
   let capData= [];
   let capilartyData = '';
   let capAddr = '';
   let capZip = '';
   if(capillaryFlag == 'Y') {
   capData = await this.props.capillarySearchMember(data);
     capilartyData = capData && capData.data && capData.data.data.length > 0 && capData.data.data[0].customer_details ? capData.data.data[0].customer_details : '';
        capAddr = capilartyData != '' && capilartyData.custom_fields ? capilartyData.custom_fields : '' ;
        capZip = capilartyData != '' && capilartyData.extended_fields ? capilartyData.extended_fields : '' ;
   }
   
    if(capZip != '' && capZip.zip){
    this.getStateCityByZipcode('ship_pin',capZip.zip)
   }
   console.log(capZip.zip)
    this.setState({
      ship_addr_1: capillaryFlag && capillaryFlag == 'Y' ? capAddr != '' && capAddr.addressone : this.props.userDetails.COM_ADDRESS1,
      ship_addr_2: capillaryFlag && capillaryFlag == 'Y' ? capAddr != '' && capAddr.addresstwo :this.props.userDetails.COM_ADDRESS2,
      ship_addr_3: capillaryFlag && capillaryFlag == 'Y' ? capAddr != '' && capAddr.addressthree:this.props.userDetails.COM_ADDRESS3,
     
      ship_pin: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.zip || '': this.props.userDetails.COM_PIN,
      ship_town_name: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.city || '': this.props.userDetails.COM_TOWN_NAME,
      // ship_town: this.props.userDetails.COM_TOWN_NAME,
      ship_town_id: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.city || '': this.props.userDetails.COM_TOWN_CD,
      ship_state_name: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.state || '': this.props.userDetails.COM_STATE_NAME,
      ship_state_id: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.state || '':this.props.userDetails.COM_STATE_CD,
      ship_country_name: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.country_of_residence || '':this.props.userDetails.COM_CONTRY_NAME,
      ship_country_id: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.country_of_residence || '':this.props.userDetails.COM_CONTRY_CD,
      bill_addr_1: capillaryFlag && capillaryFlag == 'Y' ? capAddr != '' && capAddr.addressone || '': this.props.userDetails.COM_BILL_TO_ADDRESS1,
      bill_addr_2: capillaryFlag && capillaryFlag == 'Y' ? capAddr != '' && capAddr.addresstwo || '':this.props.userDetails.COM_BILL_TO_ADDRESS2,
      bill_addr_3: capillaryFlag && capillaryFlag == 'Y' ? capAddr != '' && capAddr.addressthree || '':this.props.userDetails.COM_BILL_TO_ADDRESS3,
      bill_pin: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.zip || '':this.props.userDetails.COM_BILL_TO_PIN,
      bill_town_name: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.city || '':this.props.userDetails.COM_BILL_TO_TOWN_NAME,
      // bill_town: this.props.userDetails.COM_BILL_TO_TOWN_NAME,
      bill_state_name: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.state || '':this.props.userDetails.COM_BILL_TO_STATE_NAME,
      bill_country_name: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.country_of_residence || '':this.props.userDetails.COM_BILL_TO_CONTRY_NAME,
      bill_town_id: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.city || '':this.props.userDetails.COM_BILL_TO_TOWN_CD,
      bill_state_id: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.state || '':this.props.userDetails.COM_BILL_TO_STATE_CD,
      bill_country_id: capillaryFlag && capillaryFlag == 'Y' ? capZip != '' &&  capZip.country_of_residence || '':this.props.userDetails.COM_BILL_TO_CONTRY_CD,
      countrySelected: [{
        CON_CONTRY_CD: this.props.userDetails.COM_CONTRY_CD,
        CON_NAME: this.props.userDetails.COM_CONTRY_NAME
      }],
      stateSelected: [{
        STA_STATE_CD: this.props.userDetails.COM_STATE_CD,
        STA_NAME: this.props.userDetails.COM_STATE_NAME
      }],
      townSelected: [{
        TWN_TOWN_CD: this.props.userDetails.COM_TOWN_CD,
        TWN_NAME: this.props.userDetails.COM_TOWN_NAME
      }],
      bill_countrySelected: [{
        CON_CONTRY_CD: this.props.userDetails.COM_BILL_TO_CONTRY_CD,
        CON_NAME: this.props.userDetails.COM_BILL_TO_CONTRY_NAME
      }],
      bill_stateSelected: [{
        STA_STATE_CD: this.props.userDetails.COM_BILL_TO_STATE_CD,
        STA_NAME: this.props.userDetails.COM_BILL_TO_STATE_NAME
      }],
      bill_townSelected: [{
        TWN_TOWN_CD: this.props.userDetails.COM_BILL_TO_TOWN_CD,
        TWN_NAME: this.props.userDetails.COM_BILL_TO_TOWN_NAME
      }],
    }, () => {
      const {ship_addr_1, bill_addr_1,ship_pin, bill_pin} = this.state
      
      if (ship_addr_1 && bill_addr_1){

        if (ship_addr_1 === bill_addr_1 && ship_pin === bill_pin){
          this.setState({
            isCopy: true
          },()=>{
this.setCopyShippingAddress();
this.validator.purgeFields();
this.forceUpdate();
          })
           
        } 
        else {
      }
      } else {
      }
    })
    // 
    // 
  }

  handleBack = () => {
    // 
    this.props.history.goBack()
  }

  handleChange(event) {
    const fieldName = event.target.id;
  const fieldValue = event.target.value;
    this.setState({ [event.target.id]: event.target.value } ,() => {
      if(this.state.isCopy){
        this.setCopyShippingAddress()
        this.validator.purgeFields();
    this.forceUpdate();
      }
    });
    this.validator.showMessageFor(fieldName);

   
    
      if(event.target.id == "ship_pin" || event.target.id == "bill_pin") {
        let len = this.props.store_details && this.props.store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 5 : 6;
        if (event.target.value && event.target.value.length >= len) {
          this.getStateCityByZipcode(event.target.id, event.target.value)
        }
      }
     
  }


  // getPinDetails = (event) => {
  //   event.preventDefault();
  //   const { connection_id } = this.props;
  //   // getPincodeData(connection_id, event.target.value)
  //   const pinDetails = getPincodeDataAxios(connection_id, event.target.value)
  //   pinDetails.then((res) => {
  //     
  //     if (res.ack === "Success") {
  //       const { data } = res.results
  //       this.setState({
  //         ship_country_id: data.PNM_COUNTRY_CD,
  //         ship_country_name: data.PNM_COUNTRY_NAME,
  //         ship_state_id: data.PNM_STATE_CD,
  //         ship_state_name: data.PNM_STATE_NAME,
  //         ship_town_id: data.PNM_TOWN_CD,
  //         ship_town_name: data.PNM_TOWN_NAME,
  //       })
  //      // 
  //     }
  //     else if ((res.ack === "Failure")) {
  //       toast.error(`Failed - ${res.data.status.message}`);
  //     }
  //   })
  //   // 
  // }

  // getBillingPinDetails = (event) => {
  //   event.preventDefault();
  //   const { connection_id } = this.props;
  //   // getPincodeData(connection_id, event.target.value)
  //   const pinDetails = getPincodeDataAxios(connection_id, event.target.value)
  //   pinDetails.then((res) => {
  //     
  //     if (res.ack === "Success") {
  //       const { data } = res.results
  //       this.setState({
  //         bill_country_id: data.PNM_COUNTRY_CD,
  //         bill_country_name: data.PNM_COUNTRY_NAME,
  //         bill_state_id: data.PNM_STATE_CD,
  //         bill_state_name: data.PNM_STATE_NAME,
  //         bill_town_id: data.PNM_TOWN_CD,
  //         bill_town_name: data.PNM_TOWN_NAME,
  //       })
  //      // 
  //     }
  //     else if ((res.ack === "Failure")) {
  //       toast.error(`Failed - ${res.data.status.message}`);
  //     }
  //   })
  //   // 
  // }

  getCountrylist() {
    const { connection_id } = this.props
    this.setState({ countryLoading: true }, () => {
      axios.get(getCountryDataUrl, {
        params: {
          connection_id,
        },
      }).then((res) => this.setState({
        countryData: res.data.results.country,
        countryLoading: false,
        stateSelected: null,
        townSelected: null
      }));
    })
  }

  getStatelist() {
    const { connection_id } = this.props
    // 
    this.setState({ stateLoading: true }, () => {
      axios.get(getStateDataUrl, {
        params: {
          connection_id,
          country_code: this.state.countrySelected[0].CON_COUNTRY_CD || this.state.countrySelected[0].COM_COUNTRY_CD
        },
      }).then((res) => this.setState({
        stateData: res.data.results.state,
        stateLoading: false,

      }));
    })
  }

  getTownlist() {
    const { connection_id } = this.props
    this.setState({ townLoading: true }, () => {
      axios.get(getTownDataUrl, {
        params: {
          connection_id,
          state_id: this.state.stateSelected[0].STA_STATE_CD
        },
      }).then((res) => this.setState({
        townData: res.data.results.town,
        townLoading: false
      }));
    })
  }

  bill_getCountrylist() {
    const { connection_id } = this.props
    this.setState({ bill_countryLoading: true }, () => {
      axios.get(getCountryDataUrl, {
        params: {
          connection_id,
        },
      }).then((res) => this.setState({
        bill_countryData: res.data.results.country,
        bill_countryLoading: false,
        bill_stateSelected: null,
        bill_townSelected: null
      }));
    })
  }

  bill_getStatelist() {
    const { connection_id } = this.props
    // 
    this.setState({ stateLoading: true }, () => {
      axios.get(getStateDataUrl, {
        params: {
          connection_id,
          country_code: this.state.bill_countrySelected[0].CON_COUNTRY_CD || this.state.bill_countrySelected[0].COM_COUNTRY_CD
        },
      }).then((res) => this.setState({
        bill_stateData: res.data.results.state,
        bill_stateLoading: false,

      }));
    })
  }

  bill_getTownlist() {
    const { connection_id } = this.props
    this.setState({ townLoading: true }, () => {
      axios.get(getTownDataUrl, {
        params: {
          connection_id,
          state_id: this.state.bill_stateSelected[0].STA_STATE_CD
        },
      }).then((res) => this.setState({
        bill_townData: res.data.results.town,
        bill_townLoading: false
      }));
    })
  }

  getStateCityByZipcode = (id, value) => {
    const { connection_id } = this.props;
    axios.get(getStateCityZipUrl, {
      params: {
        connection_id,
        zipcode: value
      },
    }).then((res, err) => {
      if (id == "ship_pin") {
        if (res.data.ack == "Failure") {
          this.setState({
            ship_country_id:'',
            ship_country_name: '',
            ship_state_name: '',
            ship_state_id: '',
            ship_town_name:'',
            ship_town_id: '',
      ship_pin: "",

          })
          toast.error(res.data.status.message)
        } else {
         if( this.state.isCopy) {
          this.setState({
            ship_country_name: res.data.results && res.data.results.data.CON_NAME,
            ship_country_id: res.data.results && res.data.results.data.PNM_COUNTRY_CD,
            ship_state_name: res.data.results && res.data.results.data.LPN_STATE_NAME,
            ship_state_id: res.data.results && res.data.results.data.PNM_STATE_CD,
            ship_town_name: res.data.results && res.data.results.data.LPN_TOWN_NAME,
            ship_town_id: res.data.results && res.data.results.data.PNM_TOWN_CD,
            bill_country_name: res.data.results && res.data.results.data.CON_NAME,
            bill_country_id: res.data.results && res.data.results.data.PNM_COUNTRY_CD,
            bill_state_name: res.data.results && res.data.results.data.LPN_STATE_NAME,
            bill_state_id: res.data.results && res.data.results.data.PNM_STATE_CD,
            bill_town_name: res.data.results && res.data.results.data.LPN_TOWN_NAME,
            bill_town_id: res.data.results && res.data.results.data.PNM_TOWN_CD,


          },() => {
      this.validator.showMessages();
      this.forceUpdate();
    })} else {
            this.setState({
            ship_country_name: res.data.results && res.data.results.data.CON_NAME,
            ship_country_id: res.data.results && res.data.results.data.PNM_COUNTRY_CD,
            ship_state_name: res.data.results && res.data.results.data.LPN_STATE_NAME,
            ship_state_id: res.data.results && res.data.results.data.PNM_STATE_CD,
            ship_town_name: res.data.results && res.data.results.data.LPN_TOWN_NAME,
            ship_town_id: res.data.results && res.data.results.data.PNM_TOWN_CD,
            bill_country_name:"" ,
            bill_country_id:"",
            bill_state_name: "",
            bill_state_id: "",
            bill_town_name: "",
            bill_town_id : "",
            bill_pin:""

          },() => {
      this.validator.showMessages();
      this.forceUpdate();
    })
          }
        }
      } else {
        if (res.data.ack == "Failure") {
          this.setState({
            bill_country_name:"" ,
            bill_country_id:"",
            bill_state_name: "",
            bill_state_id: "",
            bill_town_name: "",
            bill_town_id : "",
            bill_pin:""
          })
          toast.error(res.data.status.message)
        } else {
          this.setState({
            bill_country_name: res.data.results && res.data.results.data.CON_NAME,
            bill_country_id: res.data.results && res.data.results.data.PNM_COUNTRY_CD,
            bill_state_name: res.data.results && res.data.results.data.LPN_STATE_NAME,
            bill_state_id: res.data.results && res.data.results.data.PNM_STATE_CD,
            bill_town_name: res.data.results && res.data.results.data.LPN_TOWN_NAME,
            bill_town_id: res.data.results && res.data.results.data.PNM_TOWN_CD,

          })
        }
      }
    });
  }

  // setCopyShippingAddress = () => {
  //   if (!this.state.isCopy) {
  //     this.setState({
  //       bill_addr_1: this.state.ship_addr_1,
  //       bill_addr_2: this.state.ship_addr_2,
  //       bill_addr_3: this.state.ship_addr_3,
  //       bill_pin: this.state.ship_pin,
  //       bill_country_name: this.state.ship_country_name,
  //       bill_state_name: this.state.ship_state_name,
  //       bill_town_name: this.state.ship_town_name,
  //       isCopy: true
  //     })
  //   } else {
  //     this.setState({
  //       bill_addr_1: "",
  //       bill_addr_2: "",
  //       bill_addr_3: "",
  //       bill_pin: "",
  //       bill_country_name: "",
  //       bill_state_name: "",
  //       bill_town_name: "",
  //       isCopy: false
  //     })
  //   }
  // }

  setCopyShippingAddress = () => {
    if (this.state.isCopy) {
      this.setState({
        bill_addr_1: this.state.ship_addr_1,
        bill_addr_2: this.state.ship_addr_2,
        bill_addr_3: this.state.ship_addr_3,
        bill_pin: this.state.ship_pin,
        bill_country_name: this.state.ship_country_name,
        bill_country_id: this.state.ship_country_id,
        bill_state_name: this.state.ship_state_name,
        bill_state_id: this.state.ship_state_id,
        bill_town_name: this.state.ship_town_name,
        bill_town_id: this.state.ship_town_id,
      },()=>{
      })
    }else{
      this.setState({
        bill_addr_1: '',
        bill_addr_2: '',
        bill_addr_3: '',
        bill_pin: '',
        bill_country_name: '',
        bill_country_id: '',
        bill_state_name: '',
        bill_state_id: '',
        bill_town_name: '',
        bill_town_id: '',
      })
    }
  }

  handleCopyChange = (e) => {
    console.log(e.target.checked)
  
    this.setState({
      isCopy : e.target.checked
    },() => {
      // if(this.state.isCopy){
        this.setCopyShippingAddress()
        this.validator.purgeFields();
    this.forceUpdate();
      // }
    })
  }
  async handleSubmit(event) {
   
    event.preventDefault();
   // alert(this.state.isCopy)
   console.log(this.state,'state')
   console.log(this.validator.errorMessages,'errorrrr');
   

    if (this.validator.allValid()) {
      const { connection_id,store_details } = this.props
      if(this.state.isCopy){
        
        this.setState({
          bill_addr_1: this.state.ship_addr_1,
          bill_addr_2: this.state.ship_addr_2,
          bill_addr_3: this.state.ship_addr_3,
          bill_pin: this.state.ship_pin,
          bill_country_name: this.state.ship_country_name,
          bill_country_id: this.state.ship_country_id,
          bill_state_name: this.state.ship_state_name,
          bill_state_id: this.state.ship_state_id,
          bill_town_name: this.state.ship_town_name,
          bill_town_id: this.state.ship_town_id,
          bill_town_id: this.state.ship_town_id
        })
      }
   if(this.props.easyRewardsFlag === 'Y') {  let data ={
        mobile_no:localStorage.getItem('mobile_no'),
        firstName:localStorage.getItem('conFirstName'),
        username:'apiuser@BlissClub.com',
        store_code:store_details ? store_details.store_code : '' ,
        lastName:localStorage.getItem('conLastName') ? localStorage.getItem('conLastName') : '',
        emailId:localStorage.getItem('conEmailId'),  
        token: this.props.configDetails && this.props.configDetails.Token ? this.props.configDetails.Token : '',
        address1: this.state.ship_addr_1,
        address2: this.state.ship_addr_2,
        pinCode: this.state.ship_pin

      }
      let userData = {
         connection_id: connection_id,
        user_data: {
          cons_first_name: localStorage.getItem('conFirstName'),
          cons_last_name: localStorage.getItem('conLastName'),
          cons_email_id: localStorage.getItem('conEmailId'),
          cons_mobile_no:
            localStorage.getItem('mobile_no'),
        },
      }
      let userData1={
          connection_id: connection_id,
          mobile_no: localStorage.getItem('mobile_no'),
      }
      if(localStorage.getItem('newConsumer')=="Y") {
    await  this.props.registerEasyAccount(data)
    if(this.props.easyrewardsDetails.data && this.props.easyrewardsDetails.data.ReturnMessage && this.props.easyrewardsDetails.data.ReturnMessage != 'Success' ) {
      toast.error(this.props.easyrewardsDetails.data.ReturnMessage)
      return;
    }

   

      
    
    }else {

      await this.props.updateEasyProfileMember(data);
      }
   
await this.props.updateUserInfo(userData)
      await this.props.updateUser(userData1)
    }
else if(this.props.capillaryFlag === 'Y') { 
  const {userDetails} =this.props; 
   let data ={
        mobile_no:localStorage.getItem('mobile_no'),
        firstName:userDetails.COM_FNAME,
        lastName:userDetails.COM_LNAME,
        emailId:userDetails.COM_EMAIL_ID,  
        address1: this.state.ship_addr_1,
        address2: this.state.ship_addr_2,
        address3: this.state.ship_addr_3,
        pinCode: this.state.ship_pin,
         connection_id: connection_id,
         stateName : this.state.ship_state_name,
         countryName : this.state.ship_country_name,
         townName : this.state.ship_town_name
      }
      let userData = {
         connection_id: connection_id,
        user_data: {
          cons_first_name: userDetails.COM_FNAME,
          cons_last_name: userDetails.COM_LNAME,
          cons_email_id: userDetails.COM_EMAIL_ID,
          cons_mobile_no:
            localStorage.getItem('mobile_no'),
        },
      }
      let userData1={
          connection_id: connection_id,
          mobile_no: localStorage.getItem('mobile_no'),
      }
    //   if(localStorage.getItem('newConsumer') && localStorage.getItem('newConsumer')=="Y") {

    // await  this.props.registerCapillaryAccount(data)
    // if(this.props.capillaryDetails.data && this.props.capillaryDetails.data.ReturnMessage && this.props.capillaryDetails.data.ReturnMessage != 'Success' ) {
    //   toast.error(this.props.capillaryDetails.data.ReturnMessage)
    //   return;
    // }     
    
    // }else {
    //   console.log('inide elsss')

    //   await this.props.updateCapillaryProfileMember(data);
    //   }
        await this.props.updateCapillaryProfileMember(data);
   
await this.props.updateUserInfo(userData)
      await this.props.updateUser(userData1)
    }

      
  
      const options = {
        connection_id, user_data: {
          cons_mobile_no: localStorage.getItem('mobile_no'),
          ...this.state
        }
      }
      this.props.updateUserAddr(options)
      setTimeout(() => {
        this.props.history.goBack()
      }, 3000)
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  render() {
    const { userDetails ,store_details,updateEasyProfileMember,updateCapillaryProfileMember} = this.props
    //  const location = useLocation();
    //   const { state } = location || {};
    const ReactDropDownStyle = {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "1px solid #ced4da",
      borderRadius: "0px",
      marginLeft: "0px",
      "&:hover": {
        borderColor: "#ced4da"
      },
      padding: "0px"
    }
    const checkboxStyle = {
      paddingLeft: "0px",
      margin: "40px 0px"
    }
    return (
      <Fragment>
        <section className="m-0 p-0">
          <div className="container" style={{padding:15}}>
            <div className="row justify-content-center">
              <div className="col-sm-12 col-lg-6">
                <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmit(e)}>
                  <span className="nav-link" style={{ fontSize: 24, padding: "0.5rem 0" }}>
                    <i className="icofont icofont-contacts"></i>
                    Shipping address
                    </span>
                  <hr />
                  <div className="form-row">
                    <div className="col-md-12 pb-3">
                      {/* <label htmlFor="name">Address 1</label> */}
                      <input placeholder="Enter Address 1*" className="form-control" value={this.state.ship_addr_1} id="ship_addr_1"
                        onChange={(e) => this.handleChange(e)} type="text" autocomplete="new" />
                      {/* {this.validator.message('ship_addr_1', this.state.ship_addr_1, 'required|regex|max:30',{
                        messages: {
                          required: 'Please provide a shipping address1.',
                          max: 'Shipping address one may not be greater than 30 characters.',
                      },
                      })} */}
                       {this.validator.message(
              'ship_addr_1',
              this.state.ship_addr_1,
              'required|max:30|regex',{
                messages: {
                  required: 'Please provide a shipping address1.',
                  max: 'Shipping address one may not be greater than 30 characters.',
              },
              }
            )}
                    </div>
                    <div className="col-md-12 pb-3">
                      {/* <label htmlFor="name">Address 2</label> */}
                      <input placeholder="Enter Address 2*" className="form-control" value={this.state.ship_addr_2} id="ship_addr_2"
                        onChange={(e) => this.handleChange(e)} type="text" autocomplete="new" />
                      {this.validator.message('ship_addr_2', this.state.ship_addr_2, 'required|regex|max:30',{
                        messages: {
                          required: 'Please provide a shipping address2.',
                          max: 'Shipping address two may not be greater than 30 characters.',
                      },
                      })}
                    </div>
                    <div className="col-md-12 pb-3">
                      {/* <label htmlFor="review">Address 3</label> */}
                      <input placeholder="Enter Address 3" className="form-control" value={this.state.ship_addr_3} id="ship_addr_3"
                        onChange={(e) => this.handleChange(e)} type="text" autocomplete="new" />
                      {this.validator.message('ship_addr_3', this.state.ship_addr_3, 'regex|max:30',{
                        messages: {
                          max: 'Shipping address three may not be greater than 30 characters.',
                      },
                      })}
                    </div>
                    {/* <div className="col-md-12 pb-3">
                      <label htmlFor="review">Pin/Zip Code</label>
                      <input className="form-control" maxLength="6" pattern="\d*" onBlur={(e) => this.getPinDetails(e)}
                        value={this.state.ship_pin}
                        onChange={(e) => this.handleChange(e)}
                        id="ship_pin" type="number" />
                      {this.validator.message('ship pin', this.state.ship_pin, 'required|numeric')}
                    </div> */}
                    <div className="col-md-12 pb-3">
                      {/* <label htmlFor="review">Pin/Zip Code</label> */}
                      <input placeholder="Enter Pin code" className="form-control" maxLength={store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 5 : 6} pattern="\d*"
                        value={this.state.ship_pin}
                        onChange={(e) => this.handleChange(e)}
                        id="ship_pin" type="text" autocomplete="new" />
                      {this.validator.message("ship_pin", this.state.ship_pin, store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 'required|numeric|max:5':'required|numeric|max:6',{
                        messages: {
                          required: 'Please provide a Pincode.',
                          max: store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 'Pincode may not be greater than 5 characters.':'Pincode may not be greater than 6 characters.',
                          numeric : 'Please Enter only Numbers'
                      },
                      })}
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="review" style={{ fontSize: 12 }}>Country</label>
                      <input placeholder="Country Name" className="form-control" value={this.state.ship_country_name}
                        onChange={(e) => this.handleChange(e)}
                        id="ship_country_name" type="text" autocomplete="new" readOnly />
                        <input type='hidden' value={this.state.ship_country_id} id="ship_country_id"/>
                    </div>
                    
                    <div className="col-md-12">
                      <label htmlFor="review" style={{ fontSize: 12 }}>State</label>
                      <input placeholder="State Name" className="form-control" value={this.state.ship_state_name}
                        onChange={(e) => this.handleChange(e)}
                        id="ship_state_name" type="text" autocomplete="new" readOnly />
                        <input type='hidden' id='ship_state_id' value={this.state.ship_state_id} />
                    </div>
                   
                    <div className="col-md-12 mb-3">
                      <label htmlFor="review" style={{ fontSize: 12 }}>Town</label>
                      <input placeholder="Enter Town" className="form-control"
                        value={this.state.ship_town_name}
                        onChange={(e) => this.handleChange(e)}
                        id="ship_town_name" type="text" autocomplete="new" />
                      {this.validator.message('ship_town_name', this.state.ship_town_name, 'required',{
                        message:{
                          required: 'Please provide a Town name.',
                        },
                      })}
                      <input id='ship_town_id' value={this.state.ship_town_id} type="hidden" />
                    </div>

                  </div>
                  <div className="custom-control custom-checkbox collection-filter-checkbox" style={checkboxStyle}>
                    <label htmlFor="copy-shipping-address" >
                      <input className="checkbox_animated" type="checkbox" id="copy-shipping-address" name="copy-shipping-address" onChange={(e)=>this.handleCopyChange(e)}
                      checked={this.state.isCopy}/>
                      Is Billing address same as Shipping address ?
                    </label>
                  </div>
                  <span className={this.state.isCopy? 'nav-link opacity-3 d-none': 'nav-link'} style={{ fontSize: 24, padding: "0.5rem 0" }}>
                    <i className="icofont icofont-contacts"></i>
                    Billing address
                    </span>
                  <hr />
                  <div className={this.state.isCopy? 'from-row opacity-3 d-none': 'form-row'}>
                    <div className="col-md-12 pb-3">
                      {/* <label htmlFor="name">Address 1</label> */}
                      <input placeholder="Enter Address 1*" className="form-control" value={this.state.bill_addr_1} id="bill_addr_1"
                        onChange={(e) => this.handleChange(e)} type="text" autocomplete="new" />
                      {this.state.isCopy ? null : this.validator.message('bill_addr_1', this.state.bill_addr_1, 'required|regex|max:30',{
                        messages: {
                          required: 'Please provide a Billing address1.',
                          max: 'Billing address one may not be greater than 30 characters.',
                          //
                      },
                      })}
                    </div>
                    <div className="col-md-12 mb-3">
                      {/* <label htmlFor="name">Address 2</label> */}
                      <input placeholder="Enter Address 2*" className="form-control" value={this.state.bill_addr_2} id="bill_addr_2"
                        onChange={(e) => this.handleChange(e)} type="text" autocomplete="new" />
                      {this.state.isCopy ? null : this.validator.message('bill_addr_2', this.state.bill_addr_2, 'required|regex|max:30',{
                        messages: {
                          required: 'Please provide a Billing address2.',
                          max: 'Billing address two may not be greater than 30 characters.',
                      },
                      })}
                    </div>
                    <div className="col-md-12 mb-3">
                      {/* <label htmlFor="review">Address 3</label> */}
                      <input placeholder="Enter Address 3" className="form-control" value={this.state.bill_addr_3} id="bill_addr_3"
                        onChange={(e) => this.handleChange(e)} type="text" autocomplete="new" />
                      {this.validator.message('bill_addr_3', this.state.bill_addr_3, 'regex|max:30',{
                        messages: {
                          // required: 'Please provide a shipping address1.',
                          max: 'Shipping address three may not be greater than 30 characters.',
                      },
                      })}
                    </div>
                    <div className="col-md-12 mb-3">
                      {/* <label htmlFor="review">Pin/Zip Code</label> */}
                      <input placeholder="Enter Pin code" className="form-control" maxLength={store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 5 : 6} pattern="\d*" minLength={store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 5 : 6}
                        // onBlur={(e) => this.getBillingPinDetails(e)}
                        value={this.state.bill_pin}
                        onChange={(e) => this.handleChange(e)}
                        id="bill_pin" type="text" autocomplete="new" />
                      {this.state.isCopy == false  && this.validator.message('bill_pin', this.state.bill_pin, store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 'required|numeric|max:5':'required|numeric|max:6',{
                        messages: {
                          required: 'Please provide a Pincode.',
                          max: store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 'Pincode may not be greater than 5 characters.':'Pincode may not be greater than 6 characters.',
                          numeric : 'Please Enter only Numbers'
                      },
                      })}
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="review" style={{ fontSize: 12 }}>Country</label>
                      <input placeholder="Country Name" className="form-control" value={this.state.isCopy ? this.state.ship_country_name : this.state.bill_country_name}
                        onChange={(e) => this.handleChange(e)}
                        id="bill_country_name" type="text" autocomplete="new" readOnly />
                        <input type='hidden' value={this.state.isCopy ? this.state.ship_country_id : this.state.bill_country_id} id="bill_country_id" />
                    </div>
                 
                    <div className="col-md-12">
                      <label htmlFor="review" style={{ fontSize: 12 }}>State</label>
                      <input placeholder="State Name" className="form-control" value={this.state.isCopy ? this.state.ship_state_name :this.state.bill_state_name}
                        onChange={(e) => this.handleChange(e)}
                        id="bill_state_name" type="text" autocomplete="new" readOnly />
                        <input type='hidden' id="bill_state_id" value={this.state.bill_state_id} />
                    </div>
                                    <div className="col-md-12 mb-3">
                      <label htmlFor="review" style={{ fontSize: 12 }}>Town</label>
                      <input placeholder="Enter Town" className="form-control"
                        value={this.state.isCopy ? this.state.ship_town_name : this.state.bill_town_name}
                        onChange={(e) => this.handleChange(e)}
                        id="bill_town_name" type="text" autocomplete="new" />
                      {this.state.isCopy == false  && this.validator.message('bill_town_name', this.state.bill_town_name, 'required',{
                        messages: {
                          required: 'Please provide a Town name.',
                          
                      },
                      })}
                      <input id="bill_town_id" value={this.state.isCopy ? this.state.ship_town_id : this.state.bill_town_id} type="hidden"/>
                    </div>
                  </div>
                  <div className="col-md-12" style={{ paddingBottom: 100 }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ flexGrow: 5, textAlign: "left" }}>
                          <button type="button" className="btn btn-solid" style={{ width: "100%" }}
                            onClick={() => this.handleBack()}>Back</button>
                        </div>
                        <div style={{ flexGrow: 5, textAlign: "right" }}>
                          <button type="submit" className="btn btn-solid" style={{ width: "90%" }} disabled={this.props.updatingAddr}>
                            {this.props.updatingAddr ? 'Saving..' : 'Save changes'}</button>
                        </div>
                      </div>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}
const mapStateToProps = (state, ownProps) => ({
  isAuth: state.user.isAuth,
  connection_id: state.tenant.connection_id,
  userDetails: state.user.user_details,
  updatingAddr: state.updateAddr.loading,
    store_details: state.tenant.store_details,
     configDetails: state.tenant.configDetails,
     easyrewardsDetails : state.easyRewards.registerEasyAccountDetails,
       easyRewardsFlag: state.tenant.tenant_details.easy_rewards_flg || "N",
       capillaryFlag: state.tenant.tenant_details.capillary_flg || "N",
       capillaryDetails : state.easyRewards.capillaryMemberDetails
     
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getPincodeData, updateUserAddr,updateEasyProfileMember,updateCapillaryProfileMember,registerEasyAccount,updateUser,registerCapillaryAccount,updateUserInfo,capillarySearchMember},
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AddressInfo));
